import {useEffect, useState} from "react";
import axios from "axios";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {FloatLabel} from "primereact/floatlabel";
import {InputText} from "primereact/inputtext";
import {
	base,
	get_contract_instances,
	partners,
	volunteers,
	unit,
	workplace_url,
	budget_by_project_row_get,
} from "../../../api";
import DisabledFormFields from "../widgets/DisabledFormFields";
import DocumentTypeSelector from "../widgets/DocumentTypeSelector";
import AutoAddRemoveRows from "../widgets/AutoAddRemoveRows";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import ProcessCancelationForm from "./ProcessCancelationForm";
import {AutoComplete} from "primereact/autocomplete";
import {Skeleton} from "primereact/skeleton";

export default function ProcessEditDialogForm({
	selectedRow,
	setIsEditDialogVisible,
	toast,
	fetchData,
	isEditDialogVisible,
	setSelectedRow,
}) {
	const [selectedKeys, setSelectedKeys] = useState([]);
	const [inputValues, setInputValues] = useState({});
	const [proccessName, setProccessName] = useState("");
	const [selectedTypes, setSelectedTypes] = useState([]);
	const [cleanedFileNames, setCleanedFileNames] = useState([]);
	const [isCancelDialogVisible, setIsCancelDialogVisible] = useState(false);
	const [rows, setRows] = useState([
		{description: "", unit: null, price: "", count: "", expense_type: null},
	]);

	const [volunteersList, setVolunteersList] = useState([]);
	const [filteredVolunteers, setFilteredVolunteers] = useState([]);
	const [volunteersLoading, setVolunteersLoading] = useState(true);

	// Units state
	const [unitsList, setUnitsList] = useState([]);
	const [filteredUnits, setFilteredUnits] = useState([]);
	const [unitsLoading, setUnitsLoading] = useState(true);

	// Workplaces state
	const [workPlacesList, setWorkPlacesList] = useState([]);
	const [filteredWorkPlaces, setFilteredWorkPlaces] = useState([]);
	const [budgetError, setBudgetError] = useState("");

	console.log(unitsList);

	useEffect(() => {
		const fetchPartnerOrganization = async () => {
			if (selectedRow) {
				setProccessName(selectedRow?.name);
				setSelectedTypes(selectedRow?.enabled_template_types || []);

				if (selectedRow?.related_products && selectedRow.related_products.length > 0) {
					setRows(
						selectedRow.related_products.map(product => ({
							description: product.description || "",
							unit: product.unit || null,
							price: product.price || "",
							count: product.count || "",
							expense_type: product.expense_type || null,
						})),
					);
				} else {
					setRows([{description: "", unit: null, price: "", count: "", expense_type: null}]);
				}

				if (selectedRow?.contract_type?.form_fields) {
					try {
						const formFields = JSON.parse(selectedRow.contract_type.form_fields);
						const initialSelectedKeys = formFields.map(item => ({
							field_name: item.field_name,
							description: item.description || item.field_name,
							type: item.type,
						}));

						const initialInputValues = {};
						initialSelectedKeys.forEach(field => {
							if (selectedRow[field.variable] !== undefined) {
								initialInputValues[field.variable] = selectedRow[field.variable];
							}
						});

						setSelectedKeys(initialSelectedKeys);
						setInputValues(initialInputValues);

						if (
							initialSelectedKeys.some(f => f.variable === "partner_organization") &&
							!initialInputValues.partner_organization &&
							selectedRow.partner
						) {
							try {
								const partnerRes = await axios.get(`${base + partners}${selectedRow.partner}/`);
								setInputValues(prev => ({
									...prev,
									partner_organization: partnerRes.data.full_name_am || "",
								}));
							} catch (e) {
								console.error("Failed to fetch partner organization name", e);
							}
						}
					} catch (error) {
						setSelectedKeys([]);
					}
				} else {
					setSelectedKeys([]);
				}

				if (selectedRow?.contract_type?.file_templates?.length > 0) {
					const cleanedFiles = selectedRow.contract_type?.file_templates
						.map(file => {
							const fileName = file?.file_name?.split("/").pop();
							if (fileName) {
								const prefixMatch = fileName.match(/^[^_]+_/);
								const cleanedFileName = prefixMatch
									? fileName.replace(prefixMatch[0], "")
									: fileName;
								return {...file, cleanedFileName};
							}
							return null;
						})
						.filter(file => file !== null);
					setCleanedFileNames(cleanedFiles);
				}

				try {
					const res = await axios.get(base + volunteers);
					setVolunteersList(res.data);
					setFilteredVolunteers(res.data);
					setVolunteersLoading(false);
				} catch {
					setVolunteersList([]);
					setFilteredVolunteers([]);
					setVolunteersLoading(false);
				}

				// Fetch units
				try {
					const res = await axios.get(base + unit);
					setUnitsList(res.data);
					setFilteredUnits(res.data);
					setUnitsLoading(false);
				} catch {
					setUnitsList([]);
					setFilteredUnits([]);
					setUnitsLoading(false);
				}

				// Fetch workplaces
				try {
					const res = await axios.get(base + workplace_url);
					setWorkPlacesList(res.data);
					setFilteredWorkPlaces(res.data);
				} catch {
					setWorkPlacesList([]);
					setFilteredWorkPlaces([]);
				}

				if (selectedRow?.volunteer) {
					try {
						const volunteerRes = await axios.get(`${base + volunteers}${selectedRow.volunteer}/`);
						setInputValues(prev => ({
							...prev,
							volunteer_name: volunteerRes.data,
						}));
					} catch (e) {
						console.error("Failed to fetch volunteer", e);
					}
				}

				// If selectedRow.unit_of_measurement exists and field is present in selectedKeys, fetch and set it
				if (
					selectedRow?.unit_of_measurement &&
					selectedKeys.some(f => f.field_name === "unit_of_measurement")
				) {
					try {
						const res = await axios.get(`${base + unit}${selectedRow.unit_of_measurement}/`);
						setInputValues(prev => ({
							...prev,
							unit_of_measurement: res.data,
						}));
					} catch (e) {
						console.error("Failed to fetch unit", e);
					}
				}

				// Fetch budget by project row if project exists
				if (selectedRow?.project) {
					try {
						const res = await axios.get(
							`${base + budget_by_project_row_get}/${selectedRow.project}/`,
						);
						console.log("budget_by_project_row_get:", res.data);
						setBudgetError("");
					} catch (err) {
						const detail = err?.response?.data?.detail;
						if (detail === "Not found.") {
							setBudgetError("Նախագիծը չունի բյուջե");
						} else {
							setBudgetError("");
						}
						console.error("Failed to fetch budget_by_project_row_get", err);
					}
				}
			}
		};
		fetchPartnerOrganization();
	}, [selectedRow]);
	// Search function for units
	const searchUnits = e => {
		const q = typeof e.query === "string" ? e.query.toLowerCase() : "";
		const results = unitsList.filter(
			u =>
				(u.title_am || "").toLowerCase().includes(q) ||
				(u.title_en || "").toLowerCase().includes(q),
		);
		setFilteredUnits(results);
	};

	// Search function for workplaces
	const searchWorkPlace = e => {
		const q = typeof e.query === "string" ? e.query.toLowerCase() : "";
		const results = workPlacesList.filter(
			w =>
				(w.title_am || "").toLowerCase().includes(q) ||
				(w.title_en || "").toLowerCase().includes(q),
		);
		setFilteredWorkPlaces(results);
	};

	const saveData = async () => {
		let updatedRows = [...rows];

		// If no changes were made and `rows` is empty, restore original `related_products`
		if (updatedRows.length === 0 && selectedRow?.related_products?.length > 0) {
			updatedRows = selectedRow.related_products.map(product => ({
				description: product.description || "",
				unit: product.unit || null,
				price: product.price || "",
				count: product.count,
				expense_type: product.product || null, // Ensure correct field mapping
			}));
			setRows(updatedRows); // Ensure UI state updates as well
		}

		const payloadInstance = {
			name: proccessName,
			enabled_template_types: selectedTypes.map(type => type.id),
			contract_type: selectedRow.contract_type.id,
			form_fields: selectedKeys,
			inputValues: inputValues,
		};
		// If volunteer_name is an object, send its id
		if (
			inputValues.volunteer_name &&
			typeof inputValues.volunteer_name === "object" &&
			"id" in inputValues.volunteer_name
		) {
			payloadInstance.volunteer = inputValues.volunteer_name.id;
		}
		// If unit_of_measurement is an object, send its id
		if (
			inputValues.unit_of_measurement &&
			typeof inputValues.unit_of_measurement === "object" &&
			"id" in inputValues.unit_of_measurement
		) {
			payloadInstance.unit_of_measurement = inputValues.unit_of_measurement.id;
		}

		const payloadProducts = updatedRows.map(row => ({
			product: row.expense_type?.id || row.expense_type,
			price: row.price,
			unit: row.unit?.id || row.unit,
			count: row.count,
			description: row.description,
		}));

		try {
			const instanceResponse = await axios.patch(
				`${base + get_contract_instances + selectedRow?.id}/`,
				payloadInstance,
				{
					headers: {
						"Content-Type": "application/json",
					},
				},
			);

			if (instanceResponse.status === 200) {
				toast.current?.show({
					severity: "success",
					summary: "Success",
					detail: "Data saved successfully",
				});
				fetchData();
				setIsEditDialogVisible(false);
			}

			const productsResponse = await axios.post(
				`${base + get_contract_instances + selectedRow?.id}/bulk-upload/`,
				payloadProducts,
				{
					headers: {
						"Content-Type": "application/json",
					},
				},
			);

			if (productsResponse.status === 200) {
				toast.current?.show({
					severity: "success",
					summary: "Success",
					detail: "Products updated successfully",
				});
			}
		} catch (error) {
			toast.current?.show({
				severity: "error",
				summary: "Error",
				detail: "Failed to save data",
			});
		}
	};
	const [cancellationDate, setCancellationDate] = useState("");
	const [cancellationReason, setCancellationReason] = useState("");
	const [canelationBtn, setCancellationBtn] = useState(true);

	const accept = () => {
		setIsCancelDialogVisible(true);
	};

	const reject = () => {
		setIsCancelDialogVisible(false);
	};

	const canceletionConfirmDialog = () => {
		confirmDialog({
			message: "Are you sure you want to cancel the proceed?",
			header: "Cancel proceed",
			icon: "pi pi-exclamation-triangle",
			accept,
			reject,
		});
	};

	const handleCancelation = async () => {
		try {
			const response = await axios.patch(`${base + get_contract_instances}${selectedRow.id}/`, {
				canceled_date: cancellationDate,
				canceled_reason: cancellationReason,
				contract_number: selectedRow.id,
				enabled_template_types: selectedTypes.map(type => type.id),
				contract_type: selectedRow.contract_type.id,
				is_canceled: true,
			});
			setIsCancelDialogVisible(false);
			setCancellationDate("");
			setCancellationReason("");
			setCancellationBtn(true);
			setIsEditDialogVisible(false);
			console.log("Cancellation request successful:", response.data);
		} catch (error) {
			console.error("Error during cancellation request:", error);
		}
	};

	const handleInputChange = (property, value) => {
		setInputValues(prev => ({...prev, [property]: value}));
	};

	const searchVolunteers = e => {
		const q = typeof e.query === "string" ? e.query.toLowerCase() : "";
		const results = volunteersList.filter(v => (v.full_name || "").toLowerCase().includes(q));
		setFilteredVolunteers(results);
	};

	const dialogFooter = (
		<div className="pt-3">
			<div className="d-flex justify-content-between align-items-center">
				<div>
					{!isCancelDialogVisible && (
						<Button
							label="Cancel contract"
							icon="pi pi-trash"
							severity="danger"
							rounded
							className="mx-1"
							onClick={() => canceletionConfirmDialog()}
						/>
					)}
				</div>

				<div>
					{!isCancelDialogVisible ? (
						<>
							<Button
								label="Cancel"
								icon="pi pi-times"
								severity="secondary"
								rounded
								className="mx-1"
								onClick={() => setIsEditDialogVisible(false)}
							/>
							<Button
								label="Save"
								icon="pi pi-check"
								severity="primary"
								rounded
								className="mx-1"
								onClick={saveData}
							/>
						</>
					) : (
						<>
							<Button
								label="Cancel"
								icon="pi pi-times"
								severity="secondary"
								rounded
								className="mx-1"
								onClick={() => {
									setIsCancelDialogVisible(false);
									setCancellationDate("");
									setCancellationReason("");
									setCancellationBtn(true);
								}}
							/>
							<Button
								label="Cancel Process"
								icon="pi pi-check"
								severity="danger"
								rounded
								className="mx-1"
								disabled={canelationBtn}
								onClick={handleCancelation}
							/>
						</>
					)}
				</div>
			</div>
		</div>
	);

	return (
		<Dialog
			visible={isEditDialogVisible}
			onHide={() => setIsEditDialogVisible(false)}
			header={selectedRow?.contract_type?.name + " - " + selectedRow?.name}
			modal
			footer={dialogFooter}
			className="col-lg-8 col-11 mx-auto">
			{!isCancelDialogVisible ? (
				<div className="row">
					<div className="col-12 fs-5 fw-bold opacity-50 border-bottom pb-2 mb-2">Contract</div>

					<div className="col-12">
						<FloatLabel>
							<InputText
								className="w-100"
								id="proccessName"
								value={proccessName}
								onChange={e => {
									setProccessName(e.target.value);
									setSelectedRow(prevState => ({
										...prevState,
										name: e.target.value,
									}));
								}}
							/>
							<label htmlFor="proccessName">Contract Title</label>
						</FloatLabel>
					</div>

					<div className="row">
						<div className="col-12 fs-5 fw-bold opacity-50 border-bottom pb-2 mb-2">
							Contract form
						</div>
						<span className="col-12 mb-3 small fst-italic">
							Note: if there is no available variable please go back and edit the process and select
							the variables
						</span>

						<div className="col-12 mb-3">
							<div className="card b-radius b-shadow p-3">
								<div className="row">
									{/* {JSON.stringify(selectedKeys)} */}
									{selectedKeys.length > 0 ? (
										selectedKeys
											.filter(
												item =>
													typeof item.field_name === "string" && item.field_name.trim() !== "",
											)
											.map(item => {
												if (item.field_name === "work_place") {
													return (
														<div key={item.field_name} className="col-6 d-flex align-items-center">
															<div className="col-11 mb-2">
																<label className="ps-2 mb-2" htmlFor={item.field_name}>
																	{item.description}
																</label>
																<AutoComplete
																	dropdown
																	placeholder="Մուտքագրեք աշխատանքային վայր"
																	field="title_am"
																	completeMethod={searchWorkPlace}
																	suggestions={filteredWorkPlaces}
																	value={inputValues[item.field_name] || null}
																	onChange={e => handleInputChange(item.field_name, e.value)}
																	itemTemplate={item => (
																		<div className="d-grid p-1" style={{width: "300px"}}>
																			<span className="text-primary">{item?.title_am}</span>
																			<span className="text-secondary small">
																				{item?.title_en || "not provided"}
																			</span>
																		</div>
																	)}
																	className="w-100 p-0"
																/>
															</div>
														</div>
													);
												}
												if (item.field_name === "volunteer_name") {
													return (
														<div key={item.field_name} className="col-6 d-flex align-items-center">
															<div className="col-11 mb-2">
																<label className="ps-2 mb-2" htmlFor={item.field_name}>
																	{item.description}
																</label>
																{volunteersLoading ? (
																	<Skeleton width="100%" height="45px" />
																) : (
																	<AutoComplete
																		dropdown
																		placeholder="Մուտքագրեք կամավոր"
																		field="full_name"
																		completeMethod={searchVolunteers}
																		suggestions={filteredVolunteers}
																		value={inputValues[item.field_name] || ""}
																		onChange={e => handleInputChange(item.field_name, e.value)}
																		itemTemplate={vol => (
																			<div className="d-grid p-1" style={{width: "300px"}}>
																				<span className="text-primary">{vol?.full_name}</span>
																			</div>
																		)}
																		className="w-100 p-0"
																	/>
																)}
															</div>
														</div>
													);
												}
												// Unit of measurement field
												if (item.field_name === "unit_of_measurement") {
													return (
														<div key={item.field_name} className="col-6 d-flex align-items-center">
															<div className="col-11 mb-2">
																<label className="ps-2 mb-2" htmlFor={item.field_name}>
																	{item.description}
																</label>
																{unitsLoading ? (
																	<Skeleton width="100%" height="45px" />
																) : (
																	<AutoComplete
																		dropdown
																		placeholder="Մուտքագրեք միավորի անվանումը"
																		field="title_am"
																		completeMethod={searchUnits}
																		suggestions={filteredUnits}
																		value={inputValues[item.field_name] || null}
																		onChange={e => {
																			const val =
																				e.value && typeof e.value === "object" ? e.value : null;
																			handleInputChange(item.field_name, val);
																		}}
																		itemTemplate={unit => (
																			<div className="d-grid p-1" style={{width: "300px"}}>
																				<span className="text-primary">{unit?.title_am}</span>
																				<span className="text-secondary small">
																					{unit?.title_en || "not provided"}
																				</span>
																			</div>
																		)}
																		className="w-100 p-0"
																	/>
																)}
															</div>
														</div>
													);
												}
												let rawValue =
													inputValues[item.field_name] ?? selectedRow[item.field_name] ?? "";
												let value =
													rawValue instanceof Date
														? rawValue
														: typeof rawValue === "string" && /^\d{4}-\d{2}-\d{2}/.test(rawValue)
														? new Date(rawValue)
														: rawValue;
												return (
													<DisabledFormFields
														key={item.field_name}
														item={item}
														disabled={false}
														remove={false}
														handleInputChange={handleInputChange}
														inputValues={{[item.field_name]: value}}
													/>
												);
											})
									) : (
										<div className="col-12">
											<div className="d-flex justify-content-center align-items-center p-5 opacity-50">
												No fields selected
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>

					{budgetError && (
						<div className="col-12 text-danger pb-3" style={{fontWeight: "bold"}}>
							{budgetError}
						</div>
					)}

					<AutoAddRemoveRows rows={rows} setRows={setRows} />

					<div>
						<DocumentTypeSelector
							setSelectedTypes={setSelectedTypes}
							cleanedFileNames={cleanedFileNames || []}
							enabledTemplateTypes={selectedRow?.enabled_template_types || []}
							selectedRow={selectedRow?.contract_type}
						/>
					</div>
				</div>
			) : (
				<ProcessCancelationForm
					selectedRow={selectedRow}
					handleCancelation={handleCancelation}
					cancellationDate={cancellationDate}
					setCancellationDate={setCancellationDate}
					cancellationReason={cancellationReason}
					setCancellationReason={setCancellationReason}
					setCancellationBtn={setCancellationBtn}
				/>
			)}
			<ConfirmDialog />
		</Dialog>
	);
}
